<footer class="it-footer mt-5">
  <div class="container">
    <section class="py-4">
      <div class="row">
        <div class="col-lg-5 col-md-4 pb-2"></div>
        <div class="col-lg-7 col-md-8 d-flex justify-content-end">
          <div class="image-container">
            <img src="./logoregione.png" alt="Immagine 2" class="footer-image mr-3">

            <img src="./logo-exprivia.svg" alt="Immagine 1" class="footer-image ">
          </div>
        </div>
      </div>
    </section>
  </div>

  <div class="it-footer-main" *ngIf="anyContatto()">
    <div class="container">
      <section class="py-4">
        <div class="row">
          <div class="col-lg-5 col-md-4 pb-2">
            <h4><a href="#" title="Vai alla pagina: Contatti">Contatti</a></h4>
            <p>
              <ng-container *ngIf="getUfficio()"><strong>{{getUfficio()}}</strong><br></ng-container>
              <ng-container *ngIf="getTelefono()">{{getTelefono()}}<br></ng-container>
              <ng-container *ngIf="getPostaElettronica()">{{getPostaElettronica()}}</ng-container>
            </p>
            <div class="link-list-wrapper" *ngIf="getValore('posta-elettronica-certificata') != null">
              <ul class="footer-list link-list clearfix">
                <li><a class="list-item" href="#"
                    title="Vai alla pagina: Posta Elettronica Certificata">{{getValore('posta-elettronica-certificata')}}</a>
                </li>
              </ul>
            </div>
          </div>



        </div>
      </section>
    </div>
  </div>


  <div class="it-footer-small-prints clearfix">
    <div class="container">
      <!-- <h3 class="visually-hidden">Sezione Link Utili</h3> -->
      <ul class="it-footer-small-prints-list list-inline mb-0 d-flex flex-column flex-md-row">
        <li class="list-inline-item"><a href="#" title="Note Legali">Media policy</a></li>
        <li class="list-inline-item"><a href="#" title="Note Legali">Note legali</a></li>
        <li class="list-inline-item"><a href="#" title="Privacy-Cookies">Privacy policy</a></li>
        <li class="list-inline-item"><a href="#" title="Mappa del sito">Mappa del sito</a></li>
      </ul>
    </div>
  </div>

</footer>